import { useEffect, useState } from 'react';
import './App.css';
import jwt_decode from 'jwt-decode';

import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
} from 'react-router-dom';

import PoliciesAndProcedures from './pages/policies/PoliciesAndProcedures';
import CertificatesAndCrl from './pages/certificates-crl/CertificatesAndCrl';
import Legal from './pages/legal/Legal';
import HeaderSidenav from './components/sidenav/HeaderSidenav';
import CyberSidenav from './components/sidenav/CyberSidenav';
import Login from './pages/login/Login';
import Solicitar from './pages/solicitar/Solicitar';
import MySignatures from './pages/my-signatures/my-signatures';
import RedirectLogin from './components/login/RedirectLogin';
import Landing from './pages/landing/Landing';
import Dashboard from './pages/dashboard/Dashboard';

import routeConfig from './config/routeConfig';
import AuthContextProvider, {
	useAuthContext,
} from './components/auth-context/auth-context';
import Profile from './pages/profile/Profile';
import RequestSignature from './pages/request-signature/request-signature';
import Test from './pages/Test';
import CyberFooter from './components/footer/CyberFooter';
import { ProtectedRoute } from './config/ProtectedRoute';
import ProductsAndServices from './pages/products-and-services/ProductsAndServices';
import Requirements from './pages/requirements/Requirements';
import DiditCallback from './pages/request-signature/DiditCallback';
import PaymentFailure from './pages/payment-failure/payment-failure';
import VerificationStatus from './pages/verification-status/verification-status';
import { PinSetup } from './pages/pin-setup/pin-setup';
import { getUserCertificates } from './use-cases/get-user-signatures';
import { Certificate } from './entities/certificate';
import SignDocument from './pages/upload-document/SignDocument';
import SignZip from './pages/sign-zip/sign-zip';
import { MyManuscript } from './pages/my-manuscript/my-manuscript';
import { SidebarContextProvider } from './provider/sidebar/sidebar-context';
import { MyDocuments } from './pages/my-documents/my-documents';
import { SigningRequests } from './pages/signing-requests/signing-request';
import VerifyDocument from './pages/verify-document/VerifyDocument';
import DocumentLineage from './pages/document-lineage/DocumentLineage';
import ConsultCertificate from './pages/consult-certificate/ConsultCertificate';
import { getUserEmail } from './utils/get-user-email';
import { getUserName } from './utils/get-user-name';
import { Honeybadger } from '@honeybadger-io/react';
import { Toaster } from './components/ui/sonner';

function AppContent() {
	const { userProfile, isFetchingUserProfile, isAuthenticated } =
		useAuthContext();
	const userName = getUserName(userProfile) ?? '';
	const [userEmail, setUserEmail] = useState('');
	const [certificates, setCertificates] = useState<Certificate[]>([]);

	useEffect(() => {
		const userInfo = JSON.parse(localStorage.getItem('user-info')!);

		if (userInfo === null) {
			return;
		}

		const authToken: string = userInfo['id_token'];
		const decodedToken = jwt_decode<{ email: string }>(authToken);
		localStorage.setItem('user-data', JSON.stringify(decodedToken));

		const personalInfo = localStorage.getItem('personalInfo');

		if (personalInfo === null) {
			localStorage.setItem('personalInfo', 'true');
		}
	}, []);

	useEffect(() => {
		if (!userProfile) return;

		const email = getUserEmail();
		Honeybadger.setContext({
			user_email: email,
		});

		setUserEmail(email ?? '');
	}, [userProfile]);

	useEffect(() => {
		if (!isAuthenticated) return;

		getUserCertificates()
			.then((userCertificates) => {
				if (userCertificates) {
					localStorage.setItem(
						'signatures',
						JSON.stringify(userCertificates[0]) || '{}',
					);
					setCertificates(userCertificates);
				}
			})
			.catch((error) => {
				console.log(error);
				localStorage.setItem('personalInfo', 'false');
			});
	}, [isAuthenticated]);

	return (
		<Router>
			<Toaster />
			<HeaderSidenav userName={userName} userEmail={userEmail} />
			<CyberSidenav />

			<Switch>
				<Route path={routeConfig.home} exact component={Landing} />
				<ProtectedRoute
					path={routeConfig.dashboard}
					exact
					component={() => (
						<Dashboard
							isFetchingPersonalInformation={
								isFetchingUserProfile
							}
							certificates={certificates}
						/>
					)}
				/>

				<Route path={routeConfig.legal} component={() => <Legal />} />
				<Route
					path={routeConfig.verifyDocument}
					component={() => <VerifyDocument />}
				/>
				<Route
					path={routeConfig.documentLineage}
					component={DocumentLineage}
				/>
				<Route
					path={routeConfig.policies}
					component={() => <PoliciesAndProcedures />}
				/>
				<Route
					path={routeConfig.certificateAndCrl}
					component={() => <CertificatesAndCrl />}
				/>
				<Route
					path={routeConfig.consultCertificate}
					component={() => <ConsultCertificate />}
				/>
				<Route path={routeConfig.pinSetup} component={PinSetup} />
				<ProtectedRoute
					path={routeConfig.signDocument}
					component={() => <SignDocument />}
				/>
				<ProtectedRoute
					path={routeConfig.signZip}
					component={() => <SignZip />}
				/>
				{/* <Route path={routeConfig.signDocument} component={() => <SignDocument />} /> */}
				{/* <ProtectedRoute path={routeConfig.uploadDocument}  component={() => <SignDocument />} /> */}
				<ProtectedRoute
					path={routeConfig.requestSignature}
					component={RequestSignature}
				/>
				<ProtectedRoute
					path={routeConfig.mySignatures}
					component={() => <MySignatures />}
				/>
				<ProtectedRoute
					path={routeConfig.customManuscript}
					component={() => <MyManuscript />}
				/>
				{/* <ProtectedRoute path={routeConfig.uploadDocument} component={() => <UploadDocument />} /> */}
				<Route
					path={routeConfig.redirectLogin}
					component={RedirectLogin}
				/>
				<Route path={routeConfig.login} component={() => <Login />} />
				<Route path={routeConfig.solicitar} component={Solicitar} />
				<ProtectedRoute
					path={routeConfig.profile}
					component={() => <Profile />}
				/>
				<ProtectedRoute
					path={routeConfig.myDocuments}
					component={() => <MyDocuments />}
				/>
				<ProtectedRoute
					path={routeConfig.mySignatreRequests}
					component={() => <SigningRequests />}
				/>
				{/* <Route path={routeConfig.contact} component={Contact} /> */}
				<Route
					path={routeConfig.requirements}
					component={Requirements}
				/>
				<Route
					path={routeConfig.products}
					component={ProductsAndServices}
				/>
				<Route path={routeConfig.test} component={Test} />
				<Route path="/callback" component={DiditCallback} />
				<Route
					path={routeConfig.paymentFailure}
					component={PaymentFailure}
				/>
				<Route
					path={routeConfig.verificationStatus}
					component={VerificationStatus}
				/>

				<Redirect to={routeConfig.policies} />
			</Switch>

			<CyberFooter />
		</Router>
	);
}

function App() {
	return (
		<SidebarContextProvider>
			<AuthContextProvider>
				<AppContent />
			</AuthContextProvider>
		</SidebarContextProvider>
	);
}

export default App;
